import React from 'react';
import RatingDisplay from '../../../components/ReviewComp/ReviewComp';
import { all } from 'axios';

const ReviewSection = ({ allreview, currentUserId }) => {

    console.log('are we reciving productssssssssssssssssss review ')

  const userReview = allreview.find((r) => r.userid === currentUserId);
  const otherReviews = allreview.filter((r) => r.userid !== currentUserId);
  const avgRating =
  allreview.reduce((sum, r) => sum + r.rating, 0) / allreview.length;

  const ratingCounts = [5, 4, 3, 2, 1].map((star) => ({
    star,
    count: allreview.filter((r) => r.rating === star).length,
  }));
  const maxCount = Math.max(...ratingCounts.map((r) => r.count), 1);

  return (
    <div style={wrapperStyle}>
      <div style={sectionTitle}>ratings & reviews</div>
      <RatingDisplay averageRating={avgRating} totalRatings={allreview.length} />

      <div style={{ marginTop: 16,maxWidth:711 }}>
        {ratingCounts.map(({ star, count }) => {
          const width = (count / maxCount) * 100;
          return (
            <div key={star} style={barRowStyle}>
              <span style={barLabel}>{star}★</span>
              <div style={barContainer}>
                <div style={{ ...barFill, width: `${width}%` }} />
              </div>
              <span style={barCount}>{count}</span>
            </div>
          );
        })}
      </div>

      {userReview && (
        <div style={userBlockStyle}>
          <div style={subTitle}>your review</div>
          <ReviewCard review={userReview} highlight />
        </div>
      )}

      {otherReviews&&otherReviews.length>=1?<div style={{ marginTop: '16px' }}>
        <div style={subTitle}>all reviews</div>
        {otherReviews.map((r) => (
          <ReviewCard key={r.reviewid} review={r} />
        ))}
      </div>:<>
      <div style={userReviewsEmpty}>
         
      </div>
      
      </>}
    </div>
  );
};

const ReviewCard = ({ review, highlight }) => {
  const date = new Date(review.created_at).toLocaleDateString();
  return (
    <div
      style={{
        ...cardStyle,
        backgroundColor: highlight ? '#f3f4f6' : '#fff',
      }}
    >
      <div style={reviewHeaderStyle}>
        <span style={{ fontWeight: 600 }}>{review.username}</span>
        <RatingDisplay averageRating={review.rating} totalRatings={'na'} />
      </div>
      <p style={commentStyle}>{review.review_text}</p>
      <span style={dateStyle}>{date}</span>
    </div>
  );
};

// styles
const wrapperStyle = {
  padding: '16px',
  maxWidth:'1311px',
width:'100%',
  margin: 'auto',
  padding:'1rem 2rem'
};

const sectionTitle = {
  fontSize: '1rem',
  fontWeight: '400',
  marginBottom: '8px',
  color: '#555',
  textAlign:'left',
  paddingLeft:'2rem'
};

const subTitle = {
  fontSize: '1rem',
  fontWeight: '300',
  marginTop: '16px',
  marginBottom: '8px',
  color: '#999',
  textAlign:'left'
};

const userBlockStyle = {
  border: '1px solid #ddd',
  borderRadius: '6px',
  padding: '12px',
  backgroundColor: '#f9fafb',
};

const cardStyle = {
  border: '1px solid #ddd',
  borderRadius: '6px',
  padding: '12px',
  marginBottom: '12px',
};

const reviewHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '6px',
  marginRight:'4px',
  fontSize:'13px',
  padding:'5px 11px',

};

const commentStyle = {
  fontSize: '0.9rem',
  color: '#444',
  margin: '6px 0',
  textAlign:'left',
  padding:'11px 11px',
};

const dateStyle = {
  fontSize: '0.75rem',
  color: '#999',
  textAlign:'left',
  width:'100%',
  display:'inline-flex',
  padding:'11px 11px'
};

const barRowStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: 6,
  gap: 8,
};

const barLabel = {
  width: 32,
  fontSize: '0.9rem',
};

const barContainer = {
  flex: 1,
  height: 8,
  backgroundColor: '#eee',
  borderRadius: 4,
  overflow: 'hidden',
};

const barFill = {
  height: '100%',
  backgroundColor: '#fbbf24', // amber
};

const barCount = {
  width: 24,
  textAlign: 'right',
  fontSize: '0.8rem',
  color: '#666',
};

const userReviewsEmpty = {


}

export default ReviewSection;
